import { render } from "./ListReflectionView.vue?vue&type=template&id=436db2b2"
import script from "./ListReflectionView.vue?vue&type=script&lang=js"
export * from "./ListReflectionView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__